/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


let config = {  
    
    
    title : {
        key :'title',
        value : 'Flash Real Count'
    },
        
        
    
}

export default config;

